// extracted by mini-css-extract-plugin
export var chip = "_es-0";
export var filterDropdown = "_es-5";
export var filterItem = "_es-6";
export var icon = "_es-1";
export var removeButton = "_es-3";
export var removeIcon = "_es-4";
export var separator = "_es-2";